import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import { BasicImage, StyledHeading, BodyCopy, CallToAction } from "../../common"

import Blob from "../../../svg/blob.svg"

const LargeBannerWrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto 1rem;
  grid-row-gap: 1rem;

  @media ${(props) => props.theme.breakpoints.large} {
    --banner-grid-margin: ${(props) => props.theme.padding.hDesk};
    grid-template-columns: var(--banner-grid-margin) 0.8fr 1fr var(
        --banner-grid-margin
      );
    ${(props) =>
      props.short
        ? "grid-template-rows: 8rem 30vh 12rem"
        : "grid-template-rows: 8rem 60vh 12rem"};
    background: ${(props) =>
      props.$bgColor || props.theme.colors.defaultBannerBg};
    &:after {
      content: "";
      background: #fff;
      grid-row: 3;
      grid-column: 1 / span 4;
    }
  }
`

const BannerImageArea = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 4rem 14rem 3rem;
  &:before {
    content: "";
    width: 100%;
    grid-column: 1;
    grid-row: 1;
    background: ${(props) =>
      props.$bgColor || props.theme.colors.defaultBannerBg};
  }
  svg {
    grid-column: 1;
    grid-row: 2;
    position: relative;
    align-self: flex-end;
    width: 100%;
    fill: ${(props) => props.$bgColor || props.theme.colors.defaultBannerBg};
  }
  .img {
    grid-column: 1;
    grid-row: 2 / span 2;
    z-index: +1;
    position: relative;
    .gatsby-image-wrapper {
      position: absolute;
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
    }
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    grid-template-rows: 4rem 35vh 3rem;
  }
  @media ${(props) => props.theme.breakpoints.large} {
    grid-column: 3;
    grid-row: 2 / span 2;
    display: block;
    position: relative;
    &:before {
      display: none;
    }
    svg {
      display: none;
    }
    .img {
      height: 100%;
      position: absolute;
      height: 100%;
      width: 100%;
    }
  }
`
const StyledBannerText = styled(BodyCopy)`
  padding: 0 ${(props) => props.theme.padding.hMobile};
  &:after {
    content: "";
    width: 100%;
    height: 3px;
    background: ${(props) => props.theme.colors.borderColor};
    display: block;
    margin-top: 2.5rem;
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  button,
  a {
    align-self: center;
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    button,
    a {
      align-self: flex-start;
    }
  }
  @media ${(props) => props.theme.breakpoints.large} {
    grid-row: 2;
    grid-column: 2;
    padding: 0;
    h1 {
      max-width: 15em;
    }
    * {
      color: #ffff;
    }
    &:after {
      display: none;
    }
  }
`

const StyledButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`

export const LargeBanner = ({
  illustration,
  banner_title,
  banner_subtitle,
  link_type,
  link_text,
  link_target,
  page_link,
  background_color,
  short,
  right_link,
  right_link_text,
  right_link_text_colour,
  right_link_background_colour,
}) => {
  const StyledRightLink = styled(Link)`
    font-size: ${(props) => props.theme.fontSizes.bodyReg};
    color: ${(props) =>
      right_link_text_colour || props.theme.colors.buttonTextColor};
    background: ${(props) =>
      right_link_background_colour || props.theme.colors.brandColor};
    border-radius: 100rem;
    padding: 0.6rem 2.3rem;
    line-height: 1.5;
    border: none;
    display: inline-block;
    font-weight: 700;
    margin-top: 1.5rem;
    text-decoration: none;
    cursor: pointer;
    min-width: 180px;
    text-align: center;
  `

  return (
    <LargeBannerWrapper $bgColor={background_color} short={short}>
      {/* Image Area */}
      <BannerImageArea $bgColor={background_color}>
        <Blob />
        <div className="img">
          <BasicImage {...illustration} />
        </div>
      </BannerImageArea>
      {/*  */}
      <StyledBannerText>
        <StyledHeading size="h1" as="h1">
          {banner_title?.text}
        </StyledHeading>
        <StyledHeading weight="600" as="h3">
          {banner_subtitle?.text}
        </StyledHeading>
        <StyledButtonContainer>
          <CallToAction
            type={link_type}
            text={link_text}
            target={link_target}
            page={page_link}
          />
          {right_link && right_link_text && (
            <StyledRightLink to={right_link?.url}>
              {right_link_text}
            </StyledRightLink>
          )}
        </StyledButtonContainer>
      </StyledBannerText>
      <Blob />
    </LargeBannerWrapper>
  )
}
